export const partnerBalanceTotalFields = [
  { key: "partner_client_sum" },
  { key: "partner_partner_published_sum" },
  { key: "partner_anna_sum" },
  { key: "anna_partner_sum" },
  { key: "partner_partner_received_sum" },
  { key: "corrective_document_sum" },
  { key: "total_sum" },
];

export const getTotalRewardPaid = (rows = []) =>
  rows.reduce((sum, record) => sum + (Number(record?.transaction?.amount) || 0), 0);

export const getTotalRewardDifference = (total = {}, rows = []) =>
  (Number(total?.total_sum) || 0) + getTotalRewardPaid(rows);

export const getBalanceCurrency = (record = {}, fallbackCurrency = "CZK") =>
  record?.city_branch?.country_branch?.iso_4217_currency_code
  || record?.currency_iso_4217
  || fallbackCurrency;

export const getSummaryCurrency = (rows = [], fallbackCurrency = "CZK") => {
  const currencies = rows
    .map((record) => getBalanceCurrency(record, null))
    .filter(Boolean);
  const uniqueCurrencies = [...new Set(currencies)];

  return uniqueCurrencies.length === 1 ? uniqueCurrencies[0] : fallbackCurrency;
};
